import { BaseMenu } from '@components/BaseMenu';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CropIcon from '@mui/icons-material/Crop';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Divider, IconButton, MenuItem } from '@mui/material';
import { MouseEvent, useState } from 'react';
import css from './MomentMenuButton.module.scss';

type MomentMenuButtonProps = {
  momentId: string;
  onMenuOpen?: () => void;
  onDuplicate?: () => void;
  onTrimExpand?: () => void;
  onRemove?: () => void;
};

export const MomentMenuButton = ({
  momentId,
  onMenuOpen,
  onDuplicate,
  onTrimExpand,
  onRemove,
}: MomentMenuButtonProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    onMenuOpen?.();
  };

  const handleClose = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  const handleDuplicate = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(null);
    onDuplicate?.();
  };

  const handleTrimExpand = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(null);
    onTrimExpand?.();
  };

  const handleRemove = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(null);
    onRemove?.();
  };

  return (
    <>
      <IconButton
        className={css.menuButton}
        onClick={handleClick}
        aria-label="moment menu"
        aria-controls={open ? 'moment-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <MoreHorizIcon />
      </IconButton>
      <BaseMenu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <span className={css.menuTitle}>Edit moment</span>
        <Divider />
        <MenuItem onClick={handleDuplicate}>
          <span className={css.menuItemContent}>
            <ContentCopyIcon fontSize="small" className={css.menuIcon} />
            Duplicate moment
          </span>
        </MenuItem>
        <MenuItem onClick={handleTrimExpand}>
          <span className={css.menuItemContent}>
            <CropIcon fontSize="small" className={css.menuIcon} />
            Trim/expand
          </span>
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleRemove}>
          <span className={`${css.menuItemContent} ${css.dangerItem}`}>
            <DeleteIcon fontSize="small" className={css.menuIcon} />
            Remove moment
          </span>
        </MenuItem>
      </BaseMenu>
    </>
  );
};
